import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home.component';

const routes: Routes = [
  { path: '',  component: HomeComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ]
})
export class HomeRoutingModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/home/home-routing.module.ts